module.exports = __webpack_public_path__ + "img/pic_160233_3.eab44c6b.jpg";